// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
//
import { Rate } from "shared/cubiq-services";
import { OERateDisplayModel } from "./oe-rate-display.model";

export class OERateDataModel {
  public subscrKey: string = null;
  public rate: Rate = null; // for reference only
  ////
  public rateValue: CubiqTS.BigNumber = null;
  public displayModel: OERateDisplayModel = null;
  ////
  public invertedRateValue: CubiqTS.BigNumber = null;
  public invertedDisplayModel: OERateDisplayModel = null;
  ////  original ccyPair from the subscriber
  public ccyPair: string = null;
  public invertedCcyPair: string = null;
  //public ccyPairInverted: boolean = null;
  ////
  public timestamp: string = null;

  constructor(subscrKey: string) {
    this.subscrKey = subscrKey;
    this.timestamp = new Date().toString();
  }
}
